var $f0c9ecd45a629623$exports = {};
$f0c9ecd45a629623$exports = {
    "removeButtonLabel": `Elt\xe1vol\xedt\xe1s`,
    "removeDescription": `Nyomja meg a Delete billenty\u{171}t a c\xedmke elt\xe1vol\xedt\xe1s\xe1hoz.`
};


export {$f0c9ecd45a629623$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
